import { NotificationItem, NotificationStatus } from '../types';

export function filterNotificationItemsBasedOnType(
  items: NotificationItem[],
  type: NotificationStatus,
  exclude = false
) {
  return (items ?? []).filter((x) =>
    exclude
      ? x?.status.toUpperCase() !== type
      : x?.status.toUpperCase() === type
  );
}

export function useGetNotificationTabItems(items: NotificationItem[]) {
  return {
    all: filterNotificationItemsBasedOnType(
      items,
      NotificationStatus.ARCHIVED,
      true
    ),
    sent: filterNotificationItemsBasedOnType(items, NotificationStatus.SENT),
    archived: filterNotificationItemsBasedOnType(
      items,
      NotificationStatus.ARCHIVED
    ),
  };
}
